import * as React from 'react'

import { ListItem } from 'components/List'
import Content from '../../pages/shared/content'
import CO2Summary from './shared/CO2Summary'
import ExtraLuggageSummary from './shared/ExtraLuggageSummary'
import FlexibleRebookingSummary from './shared/FlexibleRebookingSummary'

const SoloExtrasSummary: React.FC = () => {
  return (
    <>
      <ListItem>
        <Content addNode contentKey="solo-hand-luggage-summary">
          Hand luggage (standard)
        </Content>
      </ListItem>
      <ExtraLuggageSummary />
      <CO2Summary />
      <FlexibleRebookingSummary />
    </>
  )
}

export default SoloExtrasSummary
